








































import { Component, Vue, Prop } from 'vue-property-decorator'
import { GradeFrameController } from '@/services/request.service'
import moment from 'moment'

@Component
export default class ViewAssessmentSheet extends Vue {
  @Prop()
  private readonly gradeTableId!: number
  @Prop()
  private readonly schoolYear!: string

  private sheetName = ''
  private frameName = ''
  private sectionName = ''
  private modifier = ''
  private modifyTime = ''
  private assessmentSheetData: Array<any> = []
  private frameType = '1310'

  private moment = moment

  private get locale(): string {
    return this.$store.state.locale
  }

  private get assessmentSheetHeader(): Array<any> {
    const frameType = this.frameType
    if (frameType === '1310' || frameType === '1312') {
      return [
        {
          title: this.$t('assessmentFrame.levelASkill'),
          dataIndex: 'levelA',
          width: '8%',
          customCell: record => {
            return {
              style: {
                backgroundColor: record.levelABackHex || '#fff',
                color: record.levelATextHex || 'rgba(0, 0, 0, 0.85)',
              },
            }
          },
          customRender: (value, record, index) => {
            const data = this.assessmentSheetData
            const currentSkillLength = data.filter(item => item.levelA === value).length
            const merged = index !== data.findIndex(item => item.levelA === value)
            return {
              children: record.levelA,
              attrs: {
                rowSpan: merged ? 0 : currentSkillLength,
              },
            }
          },
        },
        {
          title: this.$t('assessmentFrame.levelBSkill'),
          dataIndex: 'levelB',
          width: '8%',
          customCell: record => {
            return {
              style: {
                backgroundColor: record.levelBBackHex || '#fff',
                color: record.levelBTextHex || 'rgba(0, 0, 0, 0.85)',
              },
            }
          },
          customRender: (value, record, index) => {
            const data = this.assessmentSheetData
            const currentSkillLength = data.filter(item => item.levelB === value).length
            const merged = index !== data.findIndex(item => item.levelB === value)
            return {
              children: record.levelB,
              attrs: {
                rowSpan: merged ? 0 : currentSkillLength,
              },
            }
          },
        },
        {
          title: this.$t('assessmentFrame.levelCSkill'),
          dataIndex: 'levelC',
          width: '30%',
          customCell: record => {
            return {
              style: { backgroundColor: '#fff' },
            }
          },
          customRender: (value, record, index) => {
            return {
              children: record.levelC,
            }
          },
        },
        {
          title: this.$t('assessmentFrame.rubrics'),
          children: [
            {
              title: this.assessmentSheetData[0]
                ? this.locale === 'zh'
                  ? this.assessmentSheetData[0].gradingStandards[0].name
                  : this.assessmentSheetData[0].gradingStandards[0].enName
                : '',
              width: '18%',
              customCell: record => {
                return {
                  style: { backgroundColor: '#fff', verticalAlign: 'top' },
                }
              },
              customRender: (value, record, index) => {
                return {
                  children: record.gradingStandards[0].description,
                }
              },
            },
            {
              title: this.assessmentSheetData[0]
                ? this.locale === 'zh'
                  ? this.assessmentSheetData[0].gradingStandards[1].name
                  : this.assessmentSheetData[0].gradingStandards[1].enName
                : '',
              width: '18%',
              customCell: record => {
                return {
                  style: { backgroundColor: '#fff', verticalAlign: 'top' },
                }
              },
              customRender: (value, record, index) => {
                return {
                  children: record.gradingStandards[1].description,
                }
              },
            },
            {
              title: this.assessmentSheetData[0]
                ? this.locale === 'zh'
                  ? this.assessmentSheetData[0].gradingStandards[2].name
                  : this.assessmentSheetData[0].gradingStandards[2].enName
                : '',
              width: '18%',
              customCell: record => {
                return {
                  style: { backgroundColor: '#fff', verticalAlign: 'top' },
                }
              },
              customRender: (value, record, index) => {
                return {
                  children: record.gradingStandards[2].description,
                }
              },
            },
          ],
        },
      ]
    } else if (frameType === '1311') {
      return [
        {
          title: this.$t('assessmentFrame.levelASkill'),
          dataIndex: 'levelA',
          width: '6%',
          customCell: record => {
            return {
              style: {
                backgroundColor: record.backHex || '#fff',
                color: record.textHex || 'rgba(0, 0, 0, 0.85)',
              },
            }
          },
          customRender: (value, record, index) => {
            const data = this.assessmentSheetData
            const currentSkillLength = data.filter(item => item.levelA === value).length
            const merged = index !== data.findIndex(item => item.levelA === value)
            return {
              children: record.levelA,
              attrs: {
                rowSpan: merged ? 0 : currentSkillLength,
              },
            }
          },
        },
        {
          title: this.$t('assessmentFrame.levelBSkill'),
          width: '22%',
          customCell: record => {
            return {
              style: { backgroundColor: '#fff' },
            }
          },
          customRender: (value, record, index) => {
            return {
              children: record.levelB,
              attrs: {
                rowSpan: record.levelBRowSpan,
              },
            }
          },
        },
        {
          title: this.$t('assessmentFrame.rubrics'),
          children: [
            {
              title: this.assessmentSheetData[0]
                ? this.locale === 'zh'
                  ? this.assessmentSheetData[0].gradingStandards[0].name
                  : this.assessmentSheetData[0].gradingStandards[0].enName
                : '',
              width: '8%',
              customCell: record => {
                return {
                  style: { backgroundColor: '#fff', verticalAlign: 'top' },
                }
              },
              customRender: (value, record, index) => {
                return {
                  children: record.gradingStandards[0].description,
                }
              },
            },
            {
              title: this.assessmentSheetData[0]
                ? this.locale === 'zh'
                  ? this.assessmentSheetData[0].gradingStandards[1].name
                  : this.assessmentSheetData[0].gradingStandards[1].enName
                : '',
              width: '8%',
              customCell: record => {
                return {
                  style: { backgroundColor: '#fff', verticalAlign: 'top' },
                }
              },
              customRender: (value, record, index) => {
                return {
                  children: record.gradingStandards[1].description,
                }
              },
            },
            {
              title: this.assessmentSheetData[0]
                ? this.locale === 'zh'
                  ? this.assessmentSheetData[0].gradingStandards[2].name
                  : this.assessmentSheetData[0].gradingStandards[2].enName
                : '',
              width: '8%',
              customCell: record => {
                return {
                  style: { backgroundColor: '#fff', verticalAlign: 'top' },
                }
              },
              customRender: (value, record, index) => {
                return {
                  children: record.gradingStandards[2].description,
                }
              },
            },
            {
              title: this.assessmentSheetData[0]
                ? this.locale === 'zh'
                  ? this.assessmentSheetData[0].gradingStandards[3].name
                  : this.assessmentSheetData[0].gradingStandards[3].enName
                : '',
              width: '8%',
              customCell: record => {
                return {
                  style: { backgroundColor: '#fff', verticalAlign: 'top' },
                }
              },
              customRender: (value, record, index) => {
                return {
                  children: record.gradingStandards[3].description,
                }
              },
            },
            {
              title: this.assessmentSheetData[0]
                ? this.locale === 'zh'
                  ? this.assessmentSheetData[0].gradingStandards[4].name
                  : this.assessmentSheetData[0].gradingStandards[4].enName
                : '',
              width: '8%',
              customCell: record => {
                return {
                  style: { backgroundColor: '#fff', verticalAlign: 'top' },
                }
              },
              customRender: (value, record, index) => {
                return {
                  children: record.gradingStandards[4].description,
                }
              },
            },
            {
              title: this.assessmentSheetData[0]
                ? this.locale === 'zh'
                  ? this.assessmentSheetData[0].gradingStandards[5].name
                  : this.assessmentSheetData[0].gradingStandards[5].enName
                : '',
              width: '8%',
              customCell: record => {
                return {
                  style: { backgroundColor: '#fff', verticalAlign: 'top' },
                }
              },
              customRender: (value, record, index) => {
                return {
                  children: record.gradingStandards[5].description,
                }
              },
            },
            {
              title: this.assessmentSheetData[0]
                ? this.locale === 'zh'
                  ? this.assessmentSheetData[0].gradingStandards[6].name
                  : this.assessmentSheetData[0].gradingStandards[6].enName
                : '',
              width: '8%',
              customCell: record => {
                return {
                  style: { backgroundColor: '#fff', verticalAlign: 'top' },
                }
              },
              customRender: (value, record, index) => {
                return {
                  children: record.gradingStandards[6].description,
                }
              },
            },
            {
              title: this.assessmentSheetData[0]
                ? this.locale === 'zh'
                  ? this.assessmentSheetData[0].gradingStandards[7].name
                  : this.assessmentSheetData[0].gradingStandards[7].enName
                : '',
              width: '8%',
              customCell: record => {
                return {
                  style: { backgroundColor: '#fff', verticalAlign: 'top' },
                }
              },
              customRender: (value, record, index) => {
                return {
                  children: record.gradingStandards[7].description,
                }
              },
            },
            {
              title: this.assessmentSheetData[0]
                ? this.locale === 'zh'
                  ? this.assessmentSheetData[0].gradingStandards[8].name
                  : this.assessmentSheetData[0].gradingStandards[8].enName
                : '',
              width: '8%',
              customCell: record => {
                return {
                  style: { backgroundColor: '#fff', verticalAlign: 'top' },
                }
              },
              customRender: (value, record, index) => {
                return {
                  children: record.gradingStandards[8].description,
                }
              },
            },
          ],
        },
      ]
    } else {
      return []
    }
  }

  private created(): void {
    this.getSheetDetail()
  }

  private getSheetDetail(): void {
    const { gradeTableId, schoolYear } = this
    if (gradeTableId) {
      GradeFrameController.getGradeTableStructure(gradeTableId, schoolYear)
        .then(res => {
          this.sheetName = res.data.name
          this.frameName = res.data.gradeFrame?.name ?? ''
          this.sectionName = res.data.targetSections?.map(item => item.name).join(', ') ?? ''
          this.modifier = res.data.modifier
          this.modifyTime = moment(res.data.modifyTime).format('YYYY-MM-DD HH:mm')
          this.frameType = res.data.gradeFrame.type
          let assessmentSheetData = [] as any
          if (this.frameType === '1310' || this.frameType === '1312') {
            res.data.gradeClasses.forEach(levelA => {
              levelA.childClass.forEach(levelB => {
                levelB.childClass.forEach(levelC => {
                  assessmentSheetData.push({
                    levelABackHex: levelA.backHex,
                    levelBBackHex: levelB.backHex,
                    levelATextHex: levelA.textHex,
                    levelBTextHex: levelB.textHex,
                    levelA: levelA.name,
                    levelB: levelB.abbreviation
                      ? levelB.abbreviation + ': ' + levelB.name
                      : levelB.name,
                    levelC: levelC.abbreviation
                      ? levelC.abbreviation + ': ' + levelC.name
                      : levelC.name,
                    gradeClassId: levelC.gradeClassId,
                    gradingStandards: Object.values(levelC.gradingStandards).map(grade => {
                      return {
                        name: grade.name,
                        enName: grade.enName,
                        description: grade.description,
                      }
                    }),
                  })
                })
              })
            })
          } else if (this.frameType === '1311') {
            res.data.gradeClasses.forEach(levelA => {
              levelA.childClass.forEach(levelB => {
                assessmentSheetData.push({
                  levelA: levelA.abbreviation + ': ' + levelA.name,
                  levelB: levelB.abbreviation + ': ' + levelB.name,
                  backHex: levelA.backHex,
                  textHex: levelA.textHex,
                  gradeClassId: levelB.gradeClassId,
                  gradingStandards: Object.values(levelB.gradingStandards).map(grade => {
                    return {
                      name: grade.name,
                      enName: grade.enName,
                      description: grade.description,
                    }
                  }),
                })
              })
            })
          }
          this.assessmentSheetData = assessmentSheetData
        })
        .catch(err => {
          console.error(err)
        })
    }
  }
}
